var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTmf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 28,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3.64001H0V24.64H28V3.64001Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.39 6.16001H11.97V3.85001C11.97 3.73409 12.0641 3.64001 12.18 3.64001C12.2959 3.64001 12.39 3.73409 12.39 3.85001V6.16001Z",
    fill: "#A5A9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.58 6.71998H10.78C10.78 6.10146 11.2815 5.59998 11.9 5.59998H12.46C13.0785 5.59998 13.58 6.10146 13.58 6.71998Z",
    fill: "#A5A9AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 6.16001H11.97V3.85001C11.97 3.73409 12.0641 3.64001 12.18 3.64001C12.2959 3.64001 12.39 3.73409 12.39 3.85001V6.16001Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.18 3.64001C12.0641 3.64001 11.97 3.73409 11.97 3.85001V6.16001H12.39V3.85001C12.39 3.73409 12.2959 3.64001 12.18 3.64001Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.58 6.71998H10.78C10.78 6.10146 11.2815 5.59998 11.9 5.59998H12.46C13.0785 5.59998 13.58 6.10146 13.58 6.71998Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.46 5.87998C12.8251 5.87998 13.1365 6.11406 13.2521 6.43998H11.1082C11.2238 6.11406 11.5352 5.87998 11.9003 5.87998H12.46ZM12.46 5.59998H11.9C11.2815 5.59998 10.78 6.10146 10.78 6.71998H13.58C13.58 6.10146 13.0785 5.59998 12.46 5.59998Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.18 16.24C14.9635 16.24 17.22 13.9835 17.22 11.2C17.22 8.41646 14.9635 6.15997 12.18 6.15997C9.39648 6.15997 7.14 8.41646 7.14 11.2C7.14 13.9835 9.39648 16.24 12.18 16.24Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.78 11.3405C10.6529 8.64582 11.2627 6.43354 12.18 6.16894C12.1517 6.16894 12.1234 6.16362 12.0949 6.16614C10.915 6.2745 10.0736 8.51982 10.08 11.3405H10.78Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.58 11.3405C13.7071 8.64582 13.0973 6.43354 12.18 6.16894C12.2083 6.16894 12.2366 6.16362 12.2651 6.16614C13.445 6.2745 14.2864 8.51982 14.28 11.3405H13.58Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2692 11.228C15.2692 11.2596 15.267 11.2901 15.2667 11.3215H15.9566C15.9569 11.2901 15.9597 11.2596 15.9597 11.228C15.9597 8.44814 14.518 6.1947 12.7397 6.1947C12.733 6.1947 12.7266 6.1961 12.7198 6.19638C14.1291 6.21346 15.2692 8.45878 15.2692 11.228Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09076 11.228C9.09076 11.2596 9.093 11.2901 9.09328 11.3215H8.40336C8.40308 11.2901 8.40028 11.2596 8.40028 11.228C8.40028 8.44814 9.842 6.1947 11.6203 6.1947C11.627 6.1947 11.6334 6.1961 11.6402 6.19638C10.2309 6.21346 9.09076 8.45878 9.09076 11.228Z",
    fill: "#858889"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 17.64H5.03999V21.84H19.32V17.64Z",
    fill: "#CFD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 21.28H5.03999V22.4H19.32V21.28Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.084 20.86H6.356V18.83C6.356 18.6368 6.5128 18.48 6.706 18.48H6.734C6.9272 18.48 7.084 18.6368 7.084 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90009 20.86H8.17209V18.83C8.17209 18.6368 8.32889 18.48 8.52209 18.48H8.55009C8.74329 18.48 8.90009 18.6368 8.90009 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7162 20.86H9.98816V18.83C9.98816 18.6368 10.145 18.48 10.3382 18.48H10.3662C10.5594 18.48 10.7162 18.6368 10.7162 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5325 20.86H11.8045V18.83C11.8045 18.6368 11.9613 18.48 12.1545 18.48H12.1825C12.3757 18.48 12.5325 18.6368 12.5325 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3486 20.86H13.6206V18.83C13.6206 18.6368 13.7774 18.48 13.9706 18.48H13.9986C14.1918 18.48 14.3486 18.6368 14.3486 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1647 20.86H15.4367V18.83C15.4367 18.6368 15.5935 18.48 15.7867 18.48H15.8147C16.0079 18.48 16.1647 18.6368 16.1647 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9808 20.86H17.2528V18.83C17.2528 18.6368 17.4096 18.48 17.6028 18.48H17.6308C17.824 18.48 17.9808 18.6368 17.9808 18.83V20.86Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12.6H6.44V16.24H17.92V12.6Z",
    fill: "#CFD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 16.1H6.44V17.22H17.92V16.1Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12 15.68H7.42V14.07C7.42 13.8768 7.5768 13.72 7.77 13.72C7.9632 13.72 8.12 13.8768 8.12 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88988 15.68H9.18988V14C9.18988 13.8454 9.31532 13.72 9.46988 13.72H9.60988C9.76444 13.72 9.88988 13.8454 9.88988 14V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6598 15.68H10.9598V14.07C10.9598 13.8768 11.1166 13.72 11.3098 13.72C11.503 13.72 11.6598 13.8768 11.6598 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4294 15.68H12.7294V14.07C12.7294 13.8768 12.8862 13.72 13.0794 13.72C13.2726 13.72 13.4294 13.8768 13.4294 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 15.68H14.4992V14.07C14.4992 13.8768 14.656 13.72 14.8492 13.72C15.0424 13.72 15.1992 13.8768 15.1992 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9691 15.68H16.2691V14.07C16.2691 13.8768 16.4259 13.72 16.6191 13.72C16.8123 13.72 16.9691 13.8768 16.9691 14.07V15.68Z",
    fill: "#1C9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12.32H6.44V11.76C6.44 11.4506 6.6906 11.2 7 11.2H17.36C17.6694 11.2 17.92 11.4506 17.92 11.76V12.32Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 12.18H6.44V13.3H17.92V12.18Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 11.76H6.16001C5.85073 11.76 5.60001 12.0107 5.60001 12.32C5.60001 12.6293 5.85073 12.88 6.16001 12.88H18.2C18.5093 12.88 18.76 12.6293 18.76 12.32C18.76 12.0107 18.5093 11.76 18.2 11.76Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 12.88H15.4L16.52 11.76H18.2C18.5094 11.76 18.76 12.0106 18.76 12.32C18.76 12.6294 18.5094 12.88 18.2 12.88Z",
    fill: "#BABEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 11.76H16.52L15.4 12.88H18.2C18.5094 12.88 18.76 12.6294 18.76 12.32C18.76 12.0106 18.5094 11.76 18.2 11.76Z",
    fill: "#BABEBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.32 16.968H5.03999V18.088H19.32V16.968Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.18 16.52H5.18C4.87072 16.52 4.62 16.7707 4.62 17.08C4.62 17.3893 4.87072 17.64 5.18 17.64H19.18C19.4893 17.64 19.74 17.3893 19.74 17.08C19.74 16.7707 19.4893 16.52 19.18 16.52Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3257 17.1985L16.5628 16.9613H19.18C19.2452 16.9613 19.2984 17.0145 19.2984 17.0797C19.2984 17.145 19.2452 17.1982 19.18 17.1982L16.3257 17.1985Z",
    fill: "#BABEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.18 16.52H16.38L15.26 17.64H19.18C19.4894 17.64 19.74 17.3894 19.74 17.08C19.74 16.7706 19.4894 16.52 19.18 16.52Z",
    fill: "#BABEBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 22.4H4.2V24.64H20.16V22.4Z",
    fill: "#CFD3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 22.12H4.2V23.24H20.16V22.12Z",
    fill: "#858889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H4.06C3.75072 21.7 3.5 21.9507 3.5 22.26C3.5 22.5693 3.75072 22.82 4.06 22.82H20.3C20.6093 22.82 20.86 22.5693 20.86 22.26C20.86 21.9507 20.6093 21.7 20.3 21.7Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0457 22.3785L16.2828 22.1413H20.3C20.3652 22.1413 20.4184 22.1945 20.4184 22.2597C20.4184 22.325 20.3652 22.3782 20.3 22.3782L16.0457 22.3785Z",
    fill: "#BABEBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H16.1L14.98 22.82H20.3C20.6094 22.82 20.86 22.5694 20.86 22.26C20.86 21.9506 20.6094 21.7 20.3 21.7Z",
    fill: "#BABEBF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.768 23.048C24.5175 21.2985 24.5175 18.462 22.768 16.7124C21.0184 14.9629 18.1819 14.9629 16.4324 16.7124C14.6829 18.462 14.6829 21.2985 16.4324 23.048C18.1819 24.7976 21.0184 24.7976 22.768 23.048Z",
    fill: "#009245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7507 21.8051L16.3098 21.3671L18.663 18.9656L19.104 19.4066L16.7507 21.8051ZM18.6688 21.8051L16.3155 19.4066L16.7565 18.9656L19.1098 21.3671L18.6688 21.8051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7947 20.0609V19.6125H21.3071C21.5486 19.6125 21.7549 19.6464 21.9255 19.7145C22.0964 19.7823 22.2355 19.8757 22.3432 19.9946C22.451 20.1134 22.5297 20.2489 22.5796 20.4005C22.6295 20.5522 22.6547 20.7131 22.6547 20.8829C22.6547 21.1139 22.6204 21.3194 22.5515 21.4994C22.4826 21.6795 22.3848 21.8318 22.2586 21.9564C22.132 22.081 21.9844 22.175 21.8155 22.2384C21.6465 22.3018 21.463 22.3336 21.2648 22.3336C21.0874 22.3336 20.9175 22.3041 20.7552 22.2452C20.5928 22.1864 20.4476 22.0987 20.3194 21.982C20.1909 21.8653 20.0896 21.7194 20.0149 21.5438C19.9403 21.3682 19.9031 21.1651 19.9031 20.9341H20.5854C20.5854 21.0813 20.6142 21.211 20.6718 21.323C20.7294 21.435 20.8104 21.5229 20.9152 21.5862C21.0199 21.6496 21.1403 21.6814 21.2762 21.6814C21.4195 21.6814 21.5432 21.6507 21.6469 21.5897C21.7508 21.5284 21.8304 21.438 21.8863 21.3179C21.942 21.198 21.9699 21.0529 21.9699 20.8831C21.9699 20.6907 21.9388 20.5343 21.8765 20.4144C21.8142 20.2943 21.7254 20.2056 21.6102 20.1477C21.495 20.0899 21.3591 20.0611 21.2026 20.0611H20.7949L20.7947 20.0609ZM20.7947 19.4222H21.2023C21.3608 19.4222 21.4925 19.3893 21.5972 19.3236C21.702 19.2579 21.7798 19.1675 21.8308 19.0518C21.8818 18.9362 21.9072 18.804 21.9072 18.6544C21.9072 18.4982 21.8842 18.3638 21.8379 18.2518C21.7916 18.1398 21.7218 18.053 21.6284 17.992C21.5349 17.931 21.4165 17.9003 21.273 17.9003C21.1522 17.9003 21.0432 17.9291 20.9459 17.9869C20.8486 18.0447 20.7718 18.1262 20.7151 18.2316C20.6586 18.3368 20.6302 18.462 20.6302 18.6068H19.9452C19.9452 18.3442 20.0028 18.1108 20.118 17.9071C20.2332 17.7034 20.3902 17.5432 20.5892 17.4265C20.7883 17.3098 21.0125 17.2515 21.2614 17.2515C21.5277 17.2515 21.7602 17.3042 21.9592 17.4094C22.1585 17.5148 22.3136 17.6716 22.425 17.88C22.5363 18.0884 22.592 18.3466 22.592 18.6546C22.592 18.795 22.5647 18.9377 22.5099 19.0826C22.4552 19.2274 22.374 19.3595 22.2664 19.4783C22.1589 19.5971 22.025 19.6936 21.8645 19.7672C21.7041 19.8408 21.5181 19.8777 21.3069 19.8777H20.7944V19.4224L20.7947 19.4222Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.96,
    height: 8.96,
    fill: "white",
    transform: "translate(15.12 15.4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmf);
export default __webpack_public_path__ + "static/media/TMF.d2fd803e43937dbaaf706ca978789479.svg";
export { ForwardRef as ReactComponent };